import { Card, Stack, StackItem, Toggle, Typography } from '@optimus-web/core';
import { useToggle, lt } from '@mews/framework';
import { WithEnterpriseId } from '@mews-commander/types';
import { useGetOnboardingStatus } from '../useGetOnboardingStatus';
import { useUpdateOnboardingStatus } from './useUpdateOnboardingStatus';
import { EnableGoLiveDialog } from './EnableGoLiveDialog';
import { DisableGoLiveDialog } from './DisableGoLiveDialog';

export const GoLiveCard = ({ enterpriseId }: WithEnterpriseId) => {
    const { data } = useGetOnboardingStatus({ enterpriseId, extent: { actionLogs: false } });
    const { mutate, isPending } = useUpdateOnboardingStatus();
    const [dialogState, toggleDialogState] = useToggle();

    const handleConfirm = () => {
        mutate({ goLive: { value: !data.goLive }, enterpriseId }, { onSuccess: toggleDialogState });
    };

    const Dialog = data.goLive ? DisableGoLiveDialog : EnableGoLiveDialog;

    return (
        <>
            <Stack>
                <StackItem grow>
                    <Card outline padding="300">
                        <Stack spacing="400" itemAlignment="center">
                            <Stack vertical spacing="100">
                                <Typography textStyle="titleMediumStrong" as="div">
                                    {lt('OnboardingGoLiveContainerHeader')}
                                </Typography>
                                <Typography textStyle="bodyLarge" as="div">
                                    {lt('OnboardingGoLiveContainerBody')}
                                </Typography>
                            </Stack>
                            <Toggle checked={data.goLive} onChange={toggleDialogState} />
                        </Stack>
                    </Card>
                </StackItem>
            </Stack>
            <Dialog active={dialogState} onCancel={toggleDialogState} onConfirm={handleConfirm} loading={isPending} />
        </>
    );
};
